function header() {
  const c = {
    dom: {
      header: 'section-header',
      menu_dropdown: 'js-nav-item',
      menu_dropdown_btn: 'js-menu-link-btn',
      menu: 'js-dropdown-menu',
      menu_item: 'js-link-item',
      aria_expanded: 'aria-expanded',
      aria_hidden: 'aria-hidden',
      popup: 'js-has-popup',
    },
    cls: {
      active: 'is-active',
      expanded: 'is-expanded',
    },
    event: {
      click: 'click',
      keydown: 'keydown',
      focus: 'focus',
      blur: 'blur',
      mouseenter: 'mouseenter',
      mouseleave: 'mouseleave',
    },
    color: {
      black: '#000',
      transparent: 'transparent',
    },
  };

  function init() {
    addEvents();
  }

  /**
   * add events
   */
  function addEvents() {
    // ADA - opens Header menu by keyboard
    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.keydown,
      fn: menuTrigger,
    });

    // Handle focus and blur for menu_dropdown_btn to change color even without opening the menu
    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.focus,
      fn: handleFocus,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown_btn,
      event: c.event.blur,
      fn: handleBlur,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.popup,
      event: c.event.keydown,
      fn: menuTrigger,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown,
      event: c.event.mouseenter,
      fn: handleMouseEnter,
    });

    _.addEvent({
      id: c.dom.header,
      className: c.dom.menu_dropdown,
      event: c.event.mouseleave,
      fn: handleMouseLeave,
    });
  }

  /**
   * For ADA - Opens header menu by keyboard
   * @param e keyboard targeted element
   */
  function menuTrigger(e) {
    const isEnter = e.keyCode === 13;
    const isSpace = e.keyCode === 32;

    if (!isEnter && !isSpace) return;

    // Use e.composedPath() if available, otherwise fallback to a custom path builder
    const path = e.composedPath ? e.composedPath() : getPath(e.target);

    const keyboardLink = _.hasClass(path[1], c.dom.menu_dropdown);
    const keyboardSublink = _.hasClass(path[1], c.dom.popup);

    if ((keyboardLink || keyboardSublink) && e.target.tagName === 'BUTTON') {
      const currentTab = path[1];

      // Look for regular dropdown menu first, then mega menu
      const menu = currentTab.querySelector(`.${c.dom.menu}`) || currentTab.querySelector('.js-mega-menu');

      e.preventDefault();
      openMenu(e, menu);
    } else if (isEnter) {
      window.location.href = e.target.href;
    }
  }

  // Fallback function to build the event path manually
  function getPath(target) {
    const path = [];
    while (target.parentNode !== null) {
      path.push(target);
      target = target.parentNode;
    }
    path.push(document, window);
    return path;
  }

  /**
   * Handle focus for menu_dropdown_btn
   * Changes color when focused, even without opening the menu
   */
  function handleFocus(e) {
    const menuLink = e.target;
    menuLink.style.color = c.color.black;
  }

  /**
   * Handle blur for menu_dropdown_btn
   * Changes color back to transparent when losing focus, only if menu is not expanded
   */
  function handleBlur(e) {
    const menuLink = e.target;
    const tabMenu = menuLink.closest(`.${c.dom.menu_dropdown}`);

    // Only set to transparent if the menu is NOT expanded
    if (!_.hasClass(tabMenu, c.cls.expanded) && !_.hasClass(menuLink, c.dom.menu_item)) {
      menuLink.style.color = c.color.transparent;
    }
  }

  /**
   * ADA - keyboard toggle menu
   * @param element keyboard targeted element
   * @param menu current dropdown menu
   */
  function openMenu(event, menu) {
    const path = event.composedPath ? event.composedPath() : getPath(event.target);
    const tabMenu = path.find((el) => _.hasClass(el, c.dom.menu_dropdown) || _.hasClass(el, c.dom.popup)) || path[1];
    const menuLink = event.target;
    const parentTriggerButton = tabMenu.querySelector(`.${c.dom.menu_dropdown_btn}`);

    // Change the color when the menu opens and the link is focused
    menuLink.style.color = c.color.black;
    menuLink.setAttribute(c.dom.aria_expanded, 'true');

    _.addClass(tabMenu, c.cls.expanded);
    menu.setAttribute(c.dom.aria_hidden, 'false');

    menuLink.addEventListener('blur', () => {
      // Set the color to transparent only if the menu is not expanded
      if (!_.hasClass(tabMenu, c.cls.expanded)) {
        if (!_.hasClass(menuLink, c.dom.menu_item)) {
          menuLink.style.color = c.color.transparent;
        }
      }
    });

    setTimeout(() => {
      // Handle ESC key to close the menu
      const handleKeydown = (e) => {
        const escKey = e.keyCode === 27;

        if (escKey) {
          closeMenu();
          if (parentTriggerButton) parentTriggerButton.focus();
          document.removeEventListener('keydown', handleKeydown);
          document.removeEventListener('focusin', handleFocusin);
        }
      };
      document.addEventListener('keydown', handleKeydown);

      // Handle focusin to close the menu if focus leaves the menu
      const handleFocusin = (e) => {
        if (!menu.contains(e.target) && !tabMenu.contains(e.target)) {
          closeMenu();
          document.removeEventListener('focusin', handleFocusin);
        }
      };
      document.addEventListener('focusin', handleFocusin);

      // Function to close the menu
      function closeMenu() {
        _.removeClass(tabMenu, c.cls.expanded);
        menuLink.setAttribute(c.dom.aria_expanded, 'false');
        menu.setAttribute(c.dom.aria_hidden, 'true');
        if (!_.hasClass(menuLink, c.dom.menu_item)) {
          menuLink.style.color = c.color.transparent;
        }
      }
    }, 250);
  }

  function handleMouseEnter(e) {
    const tabMenu = e.currentTarget;
    const menuLink = tabMenu.querySelector(`.${c.dom.menu_dropdown_btn}`);
    const menu = tabMenu.querySelector(`.${c.dom.menu}`) || tabMenu.querySelector('.js-mega-menu');

    if (menuLink && menu) {
      _.addClass(tabMenu, c.cls.expanded);
      menuLink.setAttribute(c.dom.aria_expanded, 'true');
      menu.setAttribute(c.dom.aria_hidden, 'false');
    }
  }

  function handleMouseLeave(e) {
    const tabMenu = e.currentTarget;
    const menuLink = tabMenu.querySelector(`.${c.dom.menu_dropdown_btn}`);
    const menu = tabMenu.querySelector(`.${c.dom.menu}`) || tabMenu.querySelector('.js-mega-menu');

    if (menuLink && menu) {
      _.removeClass(tabMenu, c.cls.expanded);
      menuLink.setAttribute(c.dom.aria_expanded, 'false');
      menu.setAttribute(c.dom.aria_hidden, 'true');
    }
  }

  return init();
}

header();
